module.exports = __webpack_public_path__ + "img/ep-N-dosis.6904a53e.jpg";